import { api } from '@shared/config/axiosConfig';
import { changeLogFromDto, filtersToDto } from '@features/changeLogs/mappers/changeLogMapper';

const BASE_ENDPOINT = '/change-logs/';

export const getChangeLogs = async (filters = {}) => {
  const params = filtersToDto(filters);
  const response = await api.get(BASE_ENDPOINT, { params });
  return response.data.map(changeLogFromDto);
};